import { createColumnHelper } from '@tanstack/react-table';

import { History } from 'types/history';
import { Status } from 'types/items';

const col = createColumnHelper<History>();

export const scansItemsColumns = [
  col.accessor((scan) => scan?.rfid || '-', {
    id: 'rfid',
    header: 'RFID',
    minSize: 150,
  }),
  col.accessor((scan) => Status[(scan as any)?.previousStatus] || '-', {
    id: 'previousStatus',
    header: 'Previous Status',
    minSize: 130,
    meta: { align: 'center' },
  }),
  col.accessor((scan) => Status[scan?.status] || '-', {
    id: 'status',
    header: 'Current Status',
    minSize: 130,
    meta: { align: 'center' },
  }),
];
